import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-partner-content',
  templateUrl: './ipos-help-partner-content.component.html',
  styleUrls: ['./ipos-help-partner-content.component.scss']
})
export class IposHelpPartnerContentComponent implements OnInit {
  @Output() readonly sideNav = new EventEmitter();
  @Input() sideNavData;
  @ViewChild('reviewPC') reviewPC: ElementRef;
  @ViewChild('approvedPC') approvedPC: ElementRef;
  @ViewChild('oemPartner') oemPartner: ElementRef;
  @ViewChild('oemAuthor') oemAuthor: ElementRef;
  isReviewPartnerContent = true;
  isApprovedPartnerContent = true;
  isOEMPartner = true;
  isOEMAuthor = true;

  constructor() { }

  ngOnInit(): void {

  }
  change(data) {
    if (data === 'reviewPC') {
      setTimeout(() => {
        this.reviewPC.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'approvedPC') {
      setTimeout(() => {
        this.approvedPC.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'oemPartner') {
      setTimeout(() => {
        this.oemPartner.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'oemAuthor') {
      setTimeout(() => {
        this.oemAuthor.nativeElement.scrollIntoView();
      }, 0);
    }
  }

  showDescription(data) {
    
    if(data === 'reviewPC'){
      this.isReviewPartnerContent = !this.isReviewPartnerContent;
    }else if (data === 'approvedPC'){
      this.isApprovedPartnerContent = !this.isApprovedPartnerContent;
    } else  if (data === 'oemPartner'){
      this.isOEMPartner = !this.isOEMPartner;
    } else if(data === 'oemAuthor'){
      this.isOEMAuthor = !this.isOEMAuthor;
    }
  }


}
